import { Button } from "@/shared/ui/button";
import { PlusIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";

const NewButton = ({ path, name }: { path: string, name: string }) => {
    const navigate = useNavigate();
    return (
        <Button onClick={() => navigate(path)}>
            <PlusIcon className="h-4 w-4 mr-2" />
            Novo {name}
        </Button>
    );
};

export default NewButton;